// ─── Environment ─────────────────────────────────────────────────
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';

// ─── Candidates ──────────────────────────────────────────────────
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SORT = 'SET_SORT';

export const FETCH_CANDIDATES_REQUEST = 'FETCH_CANDIDATES_REQUEST';
export const FETCH_CANDIDATES_SUCCESS = 'FETCH_CANDIDATES_SUCCESS';
export const FETCH_CANDIDATES_FAILURE = 'FETCH_CANDIDATES_FAILURE';

// ─── Profile ─────────────────────────────────────────────────────
export const PROFILE_FETCH_REQUEST = 'PROFILE_FETCH_REQUEST';
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS';
export const PROFILE_FETCH_FAILURE = 'PROFILE_FETCH_FAILURE';
export const PROFILE_CLEAR = 'PROFILE_CLEAR';

// ─── Active ──────────────────────────────────────────────────────
export const ACTIVE_SET_FILTERS = 'ACTIVE_SET_FILTERS';
export const ACTIVE_CLEAR_FILTERS = 'ACTIVE_CLEAR_FILTERS';
export const ACTIVE_SET_PAGE = 'ACTIVE_SET_PAGE';
export const ACTIVE_SET_PAGE_SIZE = 'ACTIVE_SET_PAGE_SIZE';
export const ACTIVE_SET_SEARCH = 'ACTIVE_SET_SEARCH';
export const ACTIVE_SET_SORT = 'ACTIVE_SET_SORT';
export const ACTIVE_FETCH_REQUEST = 'ACTIVE_FETCH_REQUEST';
export const ACTIVE_FETCH_SUCCESS = 'ACTIVE_FETCH_SUCCESS';
export const ACTIVE_FETCH_FAILURE = 'ACTIVE_FETCH_FAILURE';

// ─── Applicants ──────────────────────────────────────────────────
export const APPLICANTS_SET_FILTERS = 'APPLICANTS_SET_FILTERS';
export const APPLICANTS_CLEAR_FILTERS = 'APPLICANTS_CLEAR_FILTERS';
export const APPLICANTS_SET_PAGE = 'APPLICANTS_SET_PAGE';
export const APPLICANTS_SET_PAGE_SIZE = 'APPLICANTS_SET_PAGE_SIZE';
export const APPLICANTS_SET_SEARCH = 'APPLICANTS_SET_SEARCH';
export const APPLICANTS_SET_SORT = 'APPLICANTS_SET_SORT';
export const APPLICANTS_FETCH_REQUEST = 'APPLICANTS_FETCH_REQUEST';
export const APPLICANTS_FETCH_SUCCESS = 'APPLICANTS_FETCH_SUCCESS';
export const APPLICANTS_FETCH_FAILURE = 'APPLICANTS_FETCH_FAILURE';

// ─── Interviews ──────────────────────────────────────────────────
export const INTERVIEWS_SET_TYPE = 'INTERVIEWS_SET_TYPE';
export const INTERVIEWS_SET_FILTERS = 'INTERVIEWS_SET_FILTERS';
export const INTERVIEWS_CLEAR_FILTERS = 'INTERVIEWS_CLEAR_FILTERS';
export const INTERVIEWS_SET_PAGE = 'INTERVIEWS_SET_PAGE';
export const INTERVIEWS_SET_PAGE_SIZE = 'INTERVIEWS_SET_PAGE_SIZE';
export const INTERVIEWS_SET_SEARCH = 'INTERVIEWS_SET_SEARCH';
export const INTERVIEWS_SET_SORT = 'INTERVIEWS_SET_SORT';
export const INTERVIEWS_FETCH_REQUEST = 'INTERVIEWS_FETCH_REQUEST';
export const INTERVIEWS_FETCH_SUCCESS = 'INTERVIEWS_FETCH_SUCCESS';
export const INTERVIEWS_FETCH_FAILURE = 'INTERVIEWS_FETCH_FAILURE';

// ─── Onboarding ──────────────────────────────────────────────────
export const ONBOARDING_SET_FILTERS = 'ONBOARDING_SET_FILTERS';
export const ONBOARDING_CLEAR_FILTERS = 'ONBOARDING_CLEAR_FILTERS';
export const ONBOARDING_SET_PAGE = 'ONBOARDING_SET_PAGE';
export const ONBOARDING_SET_PAGE_SIZE = 'ONBOARDING_SET_PAGE_SIZE';
export const ONBOARDING_SET_SEARCH = 'ONBOARDING_SET_SEARCH';
export const ONBOARDING_SET_SORT = 'ONBOARDING_SET_SORT';
export const ONBOARDING_FETCH_REQUEST = 'ONBOARDING_FETCH_REQUEST';
export const ONBOARDING_FETCH_SUCCESS = 'ONBOARDING_FETCH_SUCCESS';
export const ONBOARDING_FETCH_FAILURE = 'ONBOARDING_FETCH_FAILURE';

// ─── Cooldown ────────────────────────────────────────────────────
export const COOLDOWN_SET_FILTERS = 'COOLDOWN_SET_FILTERS';
export const COOLDOWN_CLEAR_FILTERS = 'COOLDOWN_CLEAR_FILTERS';
export const COOLDOWN_SET_PAGE = 'COOLDOWN_SET_PAGE';
export const COOLDOWN_SET_PAGE_SIZE = 'COOLDOWN_SET_PAGE_SIZE';
export const COOLDOWN_SET_SEARCH = 'COOLDOWN_SET_SEARCH';
export const COOLDOWN_SET_SORT = 'COOLDOWN_SET_SORT';
export const COOLDOWN_FETCH_REQUEST = 'COOLDOWN_FETCH_REQUEST';
export const COOLDOWN_FETCH_SUCCESS = 'COOLDOWN_FETCH_SUCCESS';
export const COOLDOWN_FETCH_FAILURE = 'COOLDOWN_FETCH_FAILURE';

// ─── Inactive ────────────────────────────────────────────────────
export const INACTIVE_SET_FILTERS = 'INACTIVE_SET_FILTERS';
export const INACTIVE_CLEAR_FILTERS = 'INACTIVE_CLEAR_FILTERS';
export const INACTIVE_SET_PAGE = 'INACTIVE_SET_PAGE';
export const INACTIVE_SET_PAGE_SIZE = 'INACTIVE_SET_PAGE_SIZE';
export const INACTIVE_SET_SEARCH = 'INACTIVE_SET_SEARCH';
export const INACTIVE_SET_SORT = 'INACTIVE_SET_SORT';
export const INACTIVE_FETCH_REQUEST = 'INACTIVE_FETCH_REQUEST';
export const INACTIVE_FETCH_SUCCESS = 'INACTIVE_FETCH_SUCCESS';
export const INACTIVE_FETCH_FAILURE = 'INACTIVE_FETCH_FAILURE';

// ─── Passive ─────────────────────────────────────────────────────
export const PASSIVE_SET_FILTERS = 'PASSIVE_SET_FILTERS';
export const PASSIVE_CLEAR_FILTERS = 'PASSIVE_CLEAR_FILTERS';
export const PASSIVE_SET_PAGE = 'PASSIVE_SET_PAGE';
export const PASSIVE_SET_PAGE_SIZE = 'PASSIVE_SET_PAGE_SIZE';
export const PASSIVE_SET_SEARCH = 'PASSIVE_SET_SEARCH';
export const PASSIVE_SET_SORT = 'PASSIVE_SET_SORT';
export const PASSIVE_FETCH_REQUEST = 'PASSIVE_FETCH_REQUEST';
export const PASSIVE_FETCH_SUCCESS = 'PASSIVE_FETCH_SUCCESS';
export const PASSIVE_FETCH_FAILURE = 'PASSIVE_FETCH_FAILURE';

// ─── Backlog ─────────────────────────────────────────────────────
export const BACKLOG_SET_FILTERS = 'BACKLOG_SET_FILTERS';
export const BACKLOG_CLEAR_FILTERS = 'BACKLOG_CLEAR_FILTERS';
export const BACKLOG_SET_PAGE = 'BACKLOG_SET_PAGE';
export const BACKLOG_SET_PAGE_SIZE = 'BACKLOG_SET_PAGE_SIZE';
export const BACKLOG_SET_SEARCH = 'BACKLOG_SET_SEARCH';
export const BACKLOG_SET_SORT = 'BACKLOG_SET_SORT';
export const BACKLOG_FETCH_REQUEST = 'BACKLOG_FETCH_REQUEST';
export const BACKLOG_FETCH_SUCCESS = 'BACKLOG_FETCH_SUCCESS';
export const BACKLOG_FETCH_FAILURE = 'BACKLOG_FETCH_FAILURE';
export const BACKLOG_SET_LABEL_FILTER = 'BACKLOG_SET_LABEL_FILTER';

// ─── Referrals ────────────────────────────────────────────────────
export const REFERRALS_SET_FILTERS = 'REFERRALS_SET_FILTERS';
export const REFERRALS_CLEAR_FILTERS = 'REFERRALS_CLEAR_FILTERS';
export const REFERRALS_SET_PAGE = 'REFERRALS_SET_PAGE';
export const REFERRALS_SET_PAGE_SIZE = 'REFERRALS_SET_PAGE_SIZE';
export const REFERRALS_SET_SEARCH = 'REFERRALS_SET_SEARCH';
export const REFERRALS_SET_SORT = 'REFERRALS_SET_SORT';
export const REFERRALS_FETCH_REQUEST = 'REFERRALS_FETCH_REQUEST';
export const REFERRALS_FETCH_SUCCESS = 'REFERRALS_FETCH_SUCCESS';
export const REFERRALS_FETCH_FAILURE = 'REFERRALS_FETCH_FAILURE';

// ─── Filter Options (metadata + distinct values) ────────────────
export const FETCH_FILTER_OPTIONS_REQUEST = 'FETCH_FILTER_OPTIONS_REQUEST';
export const FETCH_FILTER_OPTIONS_SUCCESS = 'FETCH_FILTER_OPTIONS_SUCCESS';
export const FETCH_FILTER_OPTIONS_FAILURE = 'FETCH_FILTER_OPTIONS_FAILURE';

// ─── Companies (global, fetched once) ────────────────────────────
export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE';

// ─── Sidebar Counts ──────────────────────────────────────────────
export const SIDEBAR_COUNTS_FETCH_REQUEST = 'SIDEBAR_COUNTS_FETCH_REQUEST';
export const SIDEBAR_COUNTS_FETCH_SUCCESS = 'SIDEBAR_COUNTS_FETCH_SUCCESS';
export const SIDEBAR_COUNTS_FETCH_FAILURE = 'SIDEBAR_COUNTS_FETCH_FAILURE';
export const INTERVIEW_VIEW_COUNTS_FETCH_SUCCESS = 'INTERVIEW_VIEW_COUNTS_FETCH_SUCCESS';

// ─── Company Profile (platform) ──────────────────────────────────
export const COMPANY_PROFILE_FETCH_REQUEST = 'COMPANY_PROFILE_FETCH_REQUEST';
export const COMPANY_PROFILE_FETCH_SUCCESS = 'COMPANY_PROFILE_FETCH_SUCCESS';
export const COMPANY_PROFILE_FETCH_FAILURE = 'COMPANY_PROFILE_FETCH_FAILURE';
export const COMPANY_PROFILE_CLEAR = 'COMPANY_PROFILE_CLEAR';
export const COMPANY_PROFILE_UPDATE_REQUEST = 'COMPANY_PROFILE_UPDATE_REQUEST';
export const COMPANY_PROFILE_UPDATE_SUCCESS = 'COMPANY_PROFILE_UPDATE_SUCCESS';
export const COMPANY_PROFILE_UPDATE_FAILURE = 'COMPANY_PROFILE_UPDATE_FAILURE';
export const COMPANY_PROFILE_INDUSTRIES_SUCCESS = 'COMPANY_PROFILE_INDUSTRIES_SUCCESS';
export const COMPANY_PROFILE_JO_FETCH_REQUEST = 'COMPANY_PROFILE_JO_FETCH_REQUEST';
export const COMPANY_PROFILE_JO_FETCH_SUCCESS = 'COMPANY_PROFILE_JO_FETCH_SUCCESS';
export const COMPANY_PROFILE_JO_FETCH_FAILURE = 'COMPANY_PROFILE_JO_FETCH_FAILURE';
export const COMPANY_PROFILE_JO_ADD_REQUEST = 'COMPANY_PROFILE_JO_ADD_REQUEST';
export const COMPANY_PROFILE_JO_ADD_SUCCESS = 'COMPANY_PROFILE_JO_ADD_SUCCESS';
export const COMPANY_PROFILE_JO_ADD_FAILURE = 'COMPANY_PROFILE_JO_ADD_FAILURE';
export const COMPANY_PROFILE_JO_DELETE_REQUEST = 'COMPANY_PROFILE_JO_DELETE_REQUEST';
export const COMPANY_PROFILE_JO_DELETE_SUCCESS = 'COMPANY_PROFILE_JO_DELETE_SUCCESS';
export const COMPANY_PROFILE_JO_DELETE_FAILURE = 'COMPANY_PROFILE_JO_DELETE_FAILURE';
export const COMPANY_PROFILE_JD_LIST_SUCCESS = 'COMPANY_PROFILE_JD_LIST_SUCCESS';

// ─── Company Manager (platform) ──────────────────────────────────
export const COMPANY_MANAGER_FETCH_REQUEST = 'COMPANY_MANAGER_FETCH_REQUEST';
export const COMPANY_MANAGER_FETCH_SUCCESS = 'COMPANY_MANAGER_FETCH_SUCCESS';
export const COMPANY_MANAGER_FETCH_FAILURE = 'COMPANY_MANAGER_FETCH_FAILURE';
export const COMPANY_MANAGER_SET_SEARCH = 'COMPANY_MANAGER_SET_SEARCH';
export const COMPANY_MANAGER_SET_SHOW_ARCHIVED = 'COMPANY_MANAGER_SET_SHOW_ARCHIVED';
export const COMPANY_MANAGER_SET_FILTERS = 'COMPANY_MANAGER_SET_FILTERS';
export const COMPANY_MANAGER_CLEAR_FILTERS = 'COMPANY_MANAGER_CLEAR_FILTERS';
export const COMPANY_MANAGER_SET_PAGE = 'COMPANY_MANAGER_SET_PAGE';
export const COMPANY_MANAGER_SET_PAGE_SIZE = 'COMPANY_MANAGER_SET_PAGE_SIZE';
export const COMPANY_MANAGER_SET_INDUSTRY_OPTIONS = 'COMPANY_MANAGER_SET_INDUSTRY_OPTIONS';
export const COMPANY_MANAGER_ADD_REQUEST = 'COMPANY_MANAGER_ADD_REQUEST';
export const COMPANY_MANAGER_ADD_SUCCESS = 'COMPANY_MANAGER_ADD_SUCCESS';
export const COMPANY_MANAGER_ADD_FAILURE = 'COMPANY_MANAGER_ADD_FAILURE';
export const COMPANY_MANAGER_FETCH_DROPDOWN_REQUEST = 'COMPANY_MANAGER_FETCH_DROPDOWN_REQUEST';
export const COMPANY_MANAGER_FETCH_DROPDOWN_SUCCESS = 'COMPANY_MANAGER_FETCH_DROPDOWN_SUCCESS';
export const COMPANY_MANAGER_FETCH_DROPDOWN_FAILURE = 'COMPANY_MANAGER_FETCH_DROPDOWN_FAILURE';

// ─── Position Tracker (platform) ─────────────────────────────────
export const POSITION_TRACKER_FETCH_REQUEST = 'POSITION_TRACKER_FETCH_REQUEST';
export const POSITION_TRACKER_FETCH_SUCCESS = 'POSITION_TRACKER_FETCH_SUCCESS';
export const POSITION_TRACKER_FETCH_FAILURE = 'POSITION_TRACKER_FETCH_FAILURE';
export const POSITION_TRACKER_SET_SEARCH = 'POSITION_TRACKER_SET_SEARCH';
export const POSITION_TRACKER_ADD_REQUEST = 'POSITION_TRACKER_ADD_REQUEST';
export const POSITION_TRACKER_ADD_SUCCESS = 'POSITION_TRACKER_ADD_SUCCESS';
export const POSITION_TRACKER_ADD_FAILURE = 'POSITION_TRACKER_ADD_FAILURE';
export const POSITION_TRACKER_UPDATE_REQUEST = 'POSITION_TRACKER_UPDATE_REQUEST';
export const POSITION_TRACKER_UPDATE_SUCCESS = 'POSITION_TRACKER_UPDATE_SUCCESS';
export const POSITION_TRACKER_UPDATE_FAILURE = 'POSITION_TRACKER_UPDATE_FAILURE';
export const POSITION_TRACKER_DELETE_REQUEST = 'POSITION_TRACKER_DELETE_REQUEST';
export const POSITION_TRACKER_DELETE_SUCCESS = 'POSITION_TRACKER_DELETE_SUCCESS';
export const POSITION_TRACKER_DELETE_FAILURE = 'POSITION_TRACKER_DELETE_FAILURE';

// ─── Matching (platform) ─────────────────────────────────────────
export const MATCHING_DETAILS_REQUEST = 'MATCHING_DETAILS_REQUEST';
export const MATCHING_DETAILS_SUCCESS = 'MATCHING_DETAILS_SUCCESS';
export const MATCHING_DETAILS_FAILURE = 'MATCHING_DETAILS_FAILURE';
export const MATCHING_SEARCH_REQUEST = 'MATCHING_SEARCH_REQUEST';
export const MATCHING_SEARCH_SUCCESS = 'MATCHING_SEARCH_SUCCESS';
export const MATCHING_SEARCH_FAILURE = 'MATCHING_SEARCH_FAILURE';
export const MATCHING_SHORTLIST_REQUEST = 'MATCHING_SHORTLIST_REQUEST';
export const MATCHING_SHORTLIST_SUCCESS = 'MATCHING_SHORTLIST_SUCCESS';
export const MATCHING_SHORTLIST_FAILURE = 'MATCHING_SHORTLIST_FAILURE';
export const MATCHING_ADD_SHORTLIST_REQUEST = 'MATCHING_ADD_SHORTLIST_REQUEST';
export const MATCHING_ADD_SHORTLIST_SUCCESS = 'MATCHING_ADD_SHORTLIST_SUCCESS';
export const MATCHING_ADD_SHORTLIST_FAILURE = 'MATCHING_ADD_SHORTLIST_FAILURE';
export const MATCHING_REMOVE_SHORTLIST_REQUEST = 'MATCHING_REMOVE_SHORTLIST_REQUEST';
export const MATCHING_REMOVE_SHORTLIST_SUCCESS = 'MATCHING_REMOVE_SHORTLIST_SUCCESS';
export const MATCHING_REMOVE_SHORTLIST_FAILURE = 'MATCHING_REMOVE_SHORTLIST_FAILURE';
export const MATCHING_AGGREGATES_SUCCESS = 'MATCHING_AGGREGATES_SUCCESS';
export const MATCHING_COMPANY_FILTERS_SUCCESS = 'MATCHING_COMPANY_FILTERS_SUCCESS';
export const MATCHING_CLEAR = 'MATCHING_CLEAR';
export const MATCHING_SET_PAGE = 'MATCHING_SET_PAGE';
export const MATCHING_MARK_VIEWED = 'MATCHING_MARK_VIEWED';
export const MATCHING_REJECTED_REQUEST = 'MATCHING_REJECTED_REQUEST';
export const MATCHING_REJECTED_SUCCESS = 'MATCHING_REJECTED_SUCCESS';
export const MATCHING_REJECTED_FAILURE = 'MATCHING_REJECTED_FAILURE';
export const MATCHING_SKIP_CANDIDATE = 'MATCHING_SKIP_CANDIDATE';
export const MATCHING_RESTORE_REJECTED_REQUEST = 'MATCHING_RESTORE_REJECTED_REQUEST';
export const MATCHING_RESTORE_REJECTED_SUCCESS = 'MATCHING_RESTORE_REJECTED_SUCCESS';
export const MATCHING_RESTORE_REJECTED_FAILURE = 'MATCHING_RESTORE_REJECTED_FAILURE';
export const MATCHING_TG_SUGGESTIONS_REQUEST = 'MATCHING_TG_SUGGESTIONS_REQUEST';
export const MATCHING_TG_SUGGESTIONS_SUCCESS = 'MATCHING_TG_SUGGESTIONS_SUCCESS';
export const MATCHING_TG_SUGGESTIONS_FAILURE = 'MATCHING_TG_SUGGESTIONS_FAILURE';
// ─── Opportunities (platform) ────────────────────────────────────
export const OPPORTUNITIES_FETCH_REQUEST = 'OPPORTUNITIES_FETCH_REQUEST';
export const OPPORTUNITIES_FETCH_SUCCESS = 'OPPORTUNITIES_FETCH_SUCCESS';
export const OPPORTUNITIES_FETCH_FAILURE = 'OPPORTUNITIES_FETCH_FAILURE';
export const OPPORTUNITIES_CREATE_REQUEST = 'OPPORTUNITIES_CREATE_REQUEST';
export const OPPORTUNITIES_CREATE_SUCCESS = 'OPPORTUNITIES_CREATE_SUCCESS';
export const OPPORTUNITIES_CREATE_FAILURE = 'OPPORTUNITIES_CREATE_FAILURE';
export const OPPORTUNITIES_UPDATE_REQUEST = 'OPPORTUNITIES_UPDATE_REQUEST';
export const OPPORTUNITIES_UPDATE_SUCCESS = 'OPPORTUNITIES_UPDATE_SUCCESS';
export const OPPORTUNITIES_UPDATE_FAILURE = 'OPPORTUNITIES_UPDATE_FAILURE';
export const OPPORTUNITIES_DELETE_REQUEST = 'OPPORTUNITIES_DELETE_REQUEST';
export const OPPORTUNITIES_DELETE_SUCCESS = 'OPPORTUNITIES_DELETE_SUCCESS';
export const OPPORTUNITIES_DELETE_FAILURE = 'OPPORTUNITIES_DELETE_FAILURE';
export const OPPORTUNITIES_MOVE_REQUEST = 'OPPORTUNITIES_MOVE_REQUEST';
export const OPPORTUNITIES_MOVE_SUCCESS = 'OPPORTUNITIES_MOVE_SUCCESS';
export const OPPORTUNITIES_MOVE_FAILURE = 'OPPORTUNITIES_MOVE_FAILURE';
export const OPPORTUNITIES_UPSERT_ONE = 'OPPORTUNITIES_UPSERT_ONE';
export const OPPORTUNITIES_REMOVE_ONE = 'OPPORTUNITIES_REMOVE_ONE';
export const OPPORTUNITIES_CLIENT_FEEDBACK_LOGGED = 'OPPORTUNITIES_CLIENT_FEEDBACK_LOGGED';

// ─── UI ──────────────────────────────────────────────────────────
export const OPEN_FILTERS_DRAWER = 'OPEN_FILTERS_DRAWER';
export const CLOSE_FILTERS_DRAWER = 'CLOSE_FILTERS_DRAWER';
export const SET_COMPACT_MODE = 'SET_COMPACT_MODE';
export const TOGGLE_COMPACT_MODE = 'TOGGLE_COMPACT_MODE';
export const SET_THEME_MODE = 'SET_THEME_MODE';
export const TOGGLE_THEME_MODE = 'TOGGLE_THEME_MODE';

// ─── Customer Success ───────────────────────────────────────────
export const CS_DASHBOARD_FETCH_REQUEST = 'CS_DASHBOARD_FETCH_REQUEST';
export const CS_DASHBOARD_FETCH_SUCCESS = 'CS_DASHBOARD_FETCH_SUCCESS';
export const CS_DASHBOARD_FETCH_FAILURE = 'CS_DASHBOARD_FETCH_FAILURE';

export const CS_COMPANIES_FETCH_REQUEST = 'CS_COMPANIES_FETCH_REQUEST';
export const CS_COMPANIES_FETCH_SUCCESS = 'CS_COMPANIES_FETCH_SUCCESS';
export const CS_COMPANIES_FETCH_FAILURE = 'CS_COMPANIES_FETCH_FAILURE';
export const CS_COMPANIES_SET_SEARCH = 'CS_COMPANIES_SET_SEARCH';
export const CS_COMPANIES_SET_HEALTH_FILTER = 'CS_COMPANIES_SET_HEALTH_FILTER';
export const CS_COMPANIES_SET_ACTIVITY_FILTER = 'CS_COMPANIES_SET_ACTIVITY_FILTER';
export const CS_COMPANIES_SET_ENGAGEMENT_FILTER = 'CS_COMPANIES_SET_ENGAGEMENT_FILTER';
export const CS_COMPANIES_SET_HAS_CONTRACT_FILTER = 'CS_COMPANIES_SET_HAS_CONTRACT_FILTER';
export const CS_COMPANIES_SET_PAGE = 'CS_COMPANIES_SET_PAGE';
export const CS_COMPANIES_SET_LIMIT = 'CS_COMPANIES_SET_LIMIT';
export const CS_COMPANY_DETAIL_FETCH_REQUEST = 'CS_COMPANY_DETAIL_FETCH_REQUEST';
export const CS_COMPANY_DETAIL_FETCH_SUCCESS = 'CS_COMPANY_DETAIL_FETCH_SUCCESS';
export const CS_COMPANY_DETAIL_FETCH_FAILURE = 'CS_COMPANY_DETAIL_FETCH_FAILURE';
export const CS_COMPANY_DETAIL_CLEAR = 'CS_COMPANY_DETAIL_CLEAR';

export const CS_CONTRACTS_FETCH_REQUEST = 'CS_CONTRACTS_FETCH_REQUEST';
export const CS_CONTRACTS_FETCH_SUCCESS = 'CS_CONTRACTS_FETCH_SUCCESS';
export const CS_CONTRACTS_FETCH_FAILURE = 'CS_CONTRACTS_FETCH_FAILURE';
export const CS_CONTRACTS_SET_SEARCH = 'CS_CONTRACTS_SET_SEARCH';
export const CS_CONTRACTS_SET_STATUS_FILTER = 'CS_CONTRACTS_SET_STATUS_FILTER';
export const CS_CONTRACT_DETAIL_FETCH_REQUEST = 'CS_CONTRACT_DETAIL_FETCH_REQUEST';
export const CS_CONTRACT_DETAIL_FETCH_SUCCESS = 'CS_CONTRACT_DETAIL_FETCH_SUCCESS';
export const CS_CONTRACT_DETAIL_FETCH_FAILURE = 'CS_CONTRACT_DETAIL_FETCH_FAILURE';
export const CS_CONTRACT_DETAIL_CLEAR = 'CS_CONTRACT_DETAIL_CLEAR';

export const CS_TALENT_FETCH_REQUEST = 'CS_TALENT_FETCH_REQUEST';
export const CS_TALENT_FETCH_SUCCESS = 'CS_TALENT_FETCH_SUCCESS';
export const CS_TALENT_FETCH_FAILURE = 'CS_TALENT_FETCH_FAILURE';
export const CS_TALENT_SET_SEARCH = 'CS_TALENT_SET_SEARCH';

export const CS_ISSUES_FETCH_REQUEST = 'CS_ISSUES_FETCH_REQUEST';
export const CS_ISSUES_FETCH_SUCCESS = 'CS_ISSUES_FETCH_SUCCESS';
export const CS_ISSUES_FETCH_FAILURE = 'CS_ISSUES_FETCH_FAILURE';
export const CS_ISSUES_SET_FILTERS = 'CS_ISSUES_SET_FILTERS';
export const CS_ISSUE_DETAIL_FETCH_REQUEST = 'CS_ISSUE_DETAIL_FETCH_REQUEST';
export const CS_ISSUE_DETAIL_FETCH_SUCCESS = 'CS_ISSUE_DETAIL_FETCH_SUCCESS';
export const CS_ISSUE_DETAIL_FETCH_FAILURE = 'CS_ISSUE_DETAIL_FETCH_FAILURE';
export const CS_ISSUE_DETAIL_CLEAR = 'CS_ISSUE_DETAIL_CLEAR';

export const CS_REPORTS_FETCH_REQUEST = 'CS_REPORTS_FETCH_REQUEST';
export const CS_REPORTS_FETCH_SUCCESS = 'CS_REPORTS_FETCH_SUCCESS';
export const CS_REPORTS_FETCH_FAILURE = 'CS_REPORTS_FETCH_FAILURE';

export const CS_EMAIL_TEMPLATES_FETCH_REQUEST = 'CS_EMAIL_TEMPLATES_FETCH_REQUEST';
export const CS_EMAIL_TEMPLATES_FETCH_SUCCESS = 'CS_EMAIL_TEMPLATES_FETCH_SUCCESS';
export const CS_EMAIL_TEMPLATES_FETCH_FAILURE = 'CS_EMAIL_TEMPLATES_FETCH_FAILURE';
export const CS_SCHEDULED_EMAILS_FETCH_REQUEST = 'CS_SCHEDULED_EMAILS_FETCH_REQUEST';
export const CS_SCHEDULED_EMAILS_FETCH_SUCCESS = 'CS_SCHEDULED_EMAILS_FETCH_SUCCESS';
export const CS_SCHEDULED_EMAILS_FETCH_FAILURE = 'CS_SCHEDULED_EMAILS_FETCH_FAILURE';
// Upsells are Redux-free (UpsellListPage / UpsellDetailPage use local state +
// apiFetch), so there are no CS_UPSELL* action types.
